import { render, staticRenderFns } from "./NotificationFileShare.vue?vue&type=template&id=5e617c6f"
import script from "./NotificationFileShare.vue?vue&type=script&lang=js"
export * from "./NotificationFileShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e617c6f')) {
      api.createRecord('5e617c6f', component.options)
    } else {
      api.reload('5e617c6f', component.options)
    }
    module.hot.accept("./NotificationFileShare.vue?vue&type=template&id=5e617c6f", function () {
      api.rerender('5e617c6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Notifications/RoomNotifications/NotificationFileShare.vue"
export default component.exports